import React from "react"

import FieldProto_ConditionForm from "../../../../proto/render/condition/condition-form"
import ConditionTypeSelector from "../../../../proto/render/condition/condition-type-selector"
import SelectMultiGenericNew from "../../../../../gd-ui/select-multi-generic-new/select-multi-generic-new"
import FieldExpenseApprovalStatus_MultiValueNotEmpty from "../components/multiselect/value-not-empty"
import FieldStatus_MultiselectPopoverOption from "../../../../generic/status/components/multiselect/option"

// const debug = "FieldExpenseApprovalStatus_ConditionForm"
const debug = false

export default class FieldExpenseApprovalStatus_ConditionForm extends FieldProto_ConditionForm {

    render() {
        debug && console.log(debug, 'render', this.state)

        return (
            <>
                <ConditionTypeSelector field    = {this.props.field}
                                       value    = {this.props.condition.type}
                                       onChange = {this.onChangeType}/>

                <SelectMultiGenericNew className                        = "selector w-250 m-l-10"
                                       options                          = {this.props.field.getOptions()}
                                       values                           = {this.props.condition.value}
                                       popoverScrollContainerClasses    = "max-h-200 max-w-300"
                                       valueComponent                   = {FieldExpenseApprovalStatus_MultiValueNotEmpty}
                                       popoverOptionComponent           = {FieldStatus_MultiselectPopoverOption}
                                       isSearchable                     = {true}
                                       // disabled                         = {disabled}
                                       onChange                         = {this.onChangeValue}/>
            </>
        )
    }
}
